import styled from "styled-components";

const DropdownContainer = styled.div`
    position: absolute;
    min-width: 170px;
    width: max-content;
    right: 2px;
    z-index: 10;
    background: #fff;
    border-radius: 5px;
    border: solid 1px #ccc;
    box-shadow: #ccc -2px 2px 2px;
`;

export default DropdownContainer;
